import React, { useContext } from 'react';

import axios from 'axios';

import { SettingsContext, UserContext } from '../contexts/index.jsx'
import { LinkHelper, ShareHelper } from "../helpers";
import { Icon, IconButton } from "./ui";

const ReferListingButton = ({
  listing,
  isProductPreview,
  isMember,
  label,
  className = '',
}) => {
  const { user } = useContext(UserContext)
  const settings = useContext(SettingsContext)

  const onClick = async (e) => {
    e.preventDefault()

    let url;

    if (isProductPreview || !user) {
      url = LinkHelper.link(`/view-product/${listing?.product?.id}?${settings.iframeQueryParams}`);
    } else {
      const { data: referral } = await axios
        .post(`/api/listings/${listing.id}/referrals`);

      if (!referral?.code) {
        return;
      }

      url = LinkHelper.listingLink(listing) + '?ref=' + referral?.code;
    }

    ShareHelper.share("Here is a product you might be interested in " + url)
  };

  if (!label) {
    label = !isProductPreview && isMember ? 'Refer to a client' : 'Share';
  }

  return (
    <IconButton
      size="lg"
      label={label}
      className={className}
      onClick={onClick}
      data-btn="listing-refer"
    >
      <Icon name="Share2" size="md" />
    </IconButton>
  );
};

export default ReferListingButton
